{
  "mar": {
    "title": "Rekod Pemberian Ubat",
    "loading": "Memuatkan rekod pemberian ubat...",
    "emptyState": "Tiada ubat aktif untuk pesakit ini",
    "loadError": "Gagal memuatkan ubat-ubatan",
    "retry": "Cuba lagi",
    "previousDay": "Hari sebelumnya",
    "nextDay": "Hari berikutnya",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "Syif",
    "dayShiftHeader": "Syif Siang (07:00 - 19:00)",
    "nightShiftHeader": "Syif Malam (19:00 - 07:00)",
    "newOrder": "Preskripsi Ubat Baharu",
    "printMar": "Cetak Rekod",
    "prnSection": "Ubat PRN (apabila perlu)",
    "filter": {
      "timeWindow": "Tetingkap masa",
      "category": "Kategori",
      "status": "Status",
      "scheduledOnly": "Hanya yang dijadualkan"
    },
    "adminStatus": {
      "scheduled": "Dijadualkan",
      "dueNow": "Tiba masa",
      "overdue": "Lewat",
      "administered": "Diberi",
      "held": "Ditangguhkan",
      "refused": "Ditolak",
      "missed": "Terlepas"
    },
    "columns": {
      "medication": "Ubat",
      "drug": "Ubat",
      "doseRoute": "Dos / Laluan",
      "schedule": "Jadual",
      "scheduledTime": "Masa dijadualkan",
      "givenTime": "Masa diberi",
      "givenBy": "Diberi oleh",
      "status": "Status"
    },
    "actions": {
      "administer": "Beri",
      "hold": "Tangguh",
      "refuse": "Tolak",
      "skip": "Langkau",
      "missed": "Tanda terlepas",
      "edit": "Sunting pemberian",
      "viewHistory": "Lihat sejarah",
      "givePrn": "Beri PRN"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "AMARAN TINGGI",
      "indication": "Indikasi: {{indication}}",
      "lastGiven": "Pemberian terakhir: {{time}}",
      "lastGivenBy": "Pemberian terakhir: {{time}} oleh {{user}}"
    },
    "orderBadge": {
      "active": "Aktif",
      "onHold": "Ditangguh",
      "discontinued": "Diberhentikan"
    },
    "legend": "Legenda:",
    "summary": {
      "medsGivenToday": "Ubat diberikan hari ini: ",
      "ofTotal": "{{given}} daripada {{total}}",
      "overdueCount_one": "{{count}} lewat",
      "overdueCount_other": "{{count}} lewat",
      "nextDue": "Seterusnya: ",
      "nextDueAt": "{{medName}} pada {{time}}"
    },
    "tooltip": {
      "given": "(diberi {{time}})",
      "pending": "Merekod… belum disahkan oleh pelayan"
    },
    "doseModal": {
      "title": "Berikan Dos",
      "doseGiven": "Dos diberi",
      "siteOfAdministration": "Lokasi pemberian",
      "comments": "Catatan",
      "vitalsCheck": "Tanda vital pra-pemberian",
      "doubleCheck": "Pengesahan dua klinisi",
      "verifier": "Pengesah",
      "confirm": "Sahkan pemberian"
    },
    "administerDialog": {
      "doseLabel": "Dos",
      "routeLabel": "Laluan",
      "siteLabel": "Lokasi pemberian (jika berkenaan)",
      "site": {
        "notApplicable": "Tidak berkenaan",
        "leftArm": "Lengan kiri",
        "rightArm": "Lengan kanan",
        "leftDeltoid": "Deltoid kiri",
        "rightDeltoid": "Deltoid kanan",
        "leftGluteal": "Punggung kiri",
        "rightGluteal": "Punggung kanan",
        "leftThigh": "Paha kiri",
        "rightThigh": "Paha kanan",
        "abdomen": "Abdomen"
      },
      "timeAdministered": "Masa Pemberian",
      "administeredDateAria": "Tarikh pemberian",
      "administeredTimeAria": "Masa pemberian",
      "notesLabel": "Catatan",
      "notesPlaceholder": "Catatan pilihan..."
    },
    "prnWarning": {
      "title": "Amaran Selang Masa PRN",
      "lastDoseHoursAgo": "Dos terakhir diberi {{hours}} jam yang lalu.",
      "minimumInterval": "Selang masa minimum ialah {{hours}} jam.",
      "lastAdministered": "Pemberian terakhir: {{time}}",
      "justificationLabel": "Justifikasi pemberian awal",
      "justificationRequired": "*",
      "justificationPlaceholder": "Masukkan justifikasi klinikal untuk memberi sebelum selang minimum...",
      "cancel": "Batal",
      "overrideContinue": "Tindih dan Teruskan"
    },
    "toast": {
      "administered": "Pemberian ubat direkodkan",
      "administerError": "Gagal merekod pemberian",
      "administerNotImplemented": "Pencatatan MAR belum tersedia",
      "held": "Ubat ditangguhkan",
      "refused": "Penolakan pesakit direkodkan",
      "skipped": "Pemberian ubat dilangkau",
      "orderNotActive": "Arahan ini tidak lagi aktif (dihentikan, dibatalkan atau selesai) dan pemberian ubat tidak boleh direkodkan."
    },
    "holdRefuseDialog": {
      "holdTitle": "Tangguh Ubat",
      "refuseTitle": "Tolak Ubat",
      "skipTitle": "Langkau Ubat",
      "scheduledLabel": "Dijadualkan: {{time}}",
      "holdReasonLabel": "Sebab menangguh",
      "refusalNotesLabel": "Catatan penolakan",
      "skipReasonLabel": "Sebab melangkau",
      "holdReasonPlaceholder": "Masukkan sebab menangguh...",
      "refusalPlaceholder": "Dokumenkan penolakan pesakit...",
      "skipPlaceholder": "Masukkan sebab melangkau...",
      "cancel": "Batal",
      "confirm": "Sahkan"
    },
    "contextMenu": {
      "hold": "Tangguh",
      "refuse": "Tolak",
      "skip": "Langkau"
    },
    "holdReason": {
      "label": "Sebab menangguh",
      "options": {
        "patientNpo": "Pesakit NPO (puasa)",
        "vitalsOutOfRange": "Tanda vital di luar julat",
        "patientRefused": "Pesakit menolak",
        "providerOrder": "Arahan doktor untuk menangguh",
        "other": "Lain-lain"
      }
    },
    "give": {
      "title": "Beri · {{medication}} {{dose}}",
      "scheduledLabel": "Dijadualkan {{time}}",
      "patientLabel": "Pesakit",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "ID Pesakit: {{id}}",
      "medicationLabel": "Ubat",
      "scanPatientPlaceholder": "Imbas gelang tangan",
      "scanPatientAria": "Imbas gelang tangan pesakit",
      "scanMedicationPlaceholder": "Imbas kod bar pada bungkusan ubat",
      "scanMedicationAria": "Imbas bungkusan ubat",
      "patientMismatch": "Gelang tangan ini bukan milik pesakit ini. Jangan beri ubat.",
      "medicationMismatch": "Bungkusan ini bukan ubat yang dipreskripsikan. Jangan beri ubat.",
      "notScannable": "Tidak boleh disahkan melalui imbasan — tiada kod bar didaftarkan bagi pesanan ini",
      "overrideReason": "Sebab memberi ubat tanpa imbasan",
      "overrideReasonPlaceholder": "cth. gelang tangan rosak; dos adunan tanpa kod bar",
      "pharmacyOverride": "Farmasi belum mengesahkan ubat amaran tinggi ini",
      "pharmacyOverridePlaceholder": "Mengapa dos ini tidak boleh menunggu semakan farmasi?",
      "timeLabel": "Masa",
      "detailsEdit": "Sunting",
      "detailsDone": "Selesai",
      "confirmLabel": "Maklumat ini sepadan dengan pesanan dan dos yang saya pegang",
      "cancel": "Batal",
      "submit": "Beri",
      "witness": {
        "banner": "AMARAN TINGGI — semakan berganda oleh jururawat kedua diperlukan",
        "usernameLabel": "Nama pengguna jururawat kedua",
        "passwordLabel": "Kata Laluan",
        "verify": "Sahkan",
        "verifying": "Mengesahkan…",
        "verified": "Telah disemak berganda oleh jururawat kedua",
        "rejected": "Butiran log masuk tidak dikenali.",
        "overrideLabel": "Tiada jururawat kedua? Beri tanpa semakan berganda — sebab",
        "overridePlaceholder": "Mengapa dos ini tidak boleh menunggu semakan berganda bebas?"
      },
      "refusal": {
        "wrongPatient": "Pesakit salah — gelang tangan yang diimbas tidak sepadan dengan pesanan ini. Jangan beri ubat.",
        "wrongMedication": "Ubat salah — bungkusan yang diimbas tidak sepadan dengan ubat yang dipreskripsikan. Jangan beri ubat.",
        "scanRequired": "Imbas gelang tangan dan ubat, atau berikan sebab tidak mengimbas.",
        "pharmacyVerificationRequired": "Farmasi belum mengesahkan pesanan ini. Tunggu pengesahan, atau rekodkan sebab ia tidak boleh menunggu.",
        "doubleCheckRequired": "Tiada jururawat kedua yang membuat semakan berganda bagi pesanan ini. Dapatkan semakan tersebut, atau rekodkan sebab ia tidak boleh menunggu.",
        "doubleCheckSelf": "Anda tidak boleh membuat semakan berganda bagi pemberian ubat anda sendiri. Jururawat kedua mesti mengesahkan dos ini."
      },
      "dispense": {
        "handedOver": "{{quantity}} diserahkan {{time}}",
        "label": "Pendispensan farmasi",
        "none": "Tiada rekod pendispensan bagi pesanan ini",
        "pending": "Pendispensan direkodkan, belum diserahkan",
        "prepared": "{{quantity}} disediakan {{time}}",
        "unavailable": "Tidak dapat menyemak pendispensan — rekod tidak dicapai"
      }
    }
  },
  "status": {
    "active": "Aktif",
    "held": "Ditangguhkan",
    "discontinued": "Diberhentikan",
    "completed": "Selesai",
    "refused": "Ditolak",
    "missed": "Terlepas",
    "given": "Diberi"
  },
  "route": {
    "po": "Oral",
    "iv": "Intravena",
    "im": "Intramuskular",
    "sc": "Subkutan",
    "in": "Intranasal",
    "pr": "Per rektal",
    "sl": "Sublingual",
    "top": "Topikal",
    "neb": "Nebulisasi",
    "pv": "Per vagina",
    "ng": "Nasogastrik",
    "ophthalmic": "Oftalmik",
    "transdermal": "Transdermal"
  },
  "frequency": {
    "bid": "Dua kali sehari",
    "tid": "Tiga kali sehari",
    "qid": "Empat kali sehari",
    "qd": "Sekali sehari",
    "qhs": "Sebelum tidur",
    "prn": "Apabila perlu (PRN)",
    "stat": "Serta-merta (STAT)",
    "continuous": "Berterusan"
  },
  "formulary": {
    "title": "Formulari Ubat",
    "searchPlaceholder": "Cari mengikut nama ubat, nama generik atau kod...",
    "clearSearch": "Kosongkan carian",
    "category": {
      "all": "Semua",
      "analgesic": "Analgesik",
      "antibiotic": "Antibiotik",
      "antifungal": "Antikulat",
      "antiviral": "Antivirus",
      "cardiac": "Kardiovaskular",
      "endocrine": "Endokrin",
      "gi": "Gastrousus",
      "neurological": "Neurologi",
      "psychiatric": "Psikiatri",
      "respiratory": "Respiratori",
      "other": "Lain-lain"
    },
    "columns": {
      "medication": "Ubat",
      "genericName": "Nama Generik",
      "form": "Bentuk",
      "strength": "Kekuatan",
      "route": "Laluan Pemberian",
      "status": "Status",
      "schedule": "Kategori Kawalan"
    },
    "highAlertBadge": "Ubat Kewaspadaan Tinggi",
    "highAlertTag": "Kewaspadaan Tinggi",
    "status": {
      "preferred": "Disyorkan",
      "restricted": "Terhad",
      "nonFormulary": "Bukan Formulari"
    },
    "loading": "Memuatkan formulari...",
    "loadError": "Gagal memuatkan formulari",
    "empty": "Tiada ubat dijumpai.",
    "pagination": {
      "showing": "Memaparkan {{from}}-{{to}} daripada {{total}}",
      "page": "Halaman {{page}} daripada {{totalPages}}",
      "previous": "Halaman sebelumnya",
      "next": "Halaman seterusnya"
    },
    "details": {
      "close": "Tutup butiran",
      "genericName": "Nama Generik",
      "category": "Kategori",
      "formStrength": "Bentuk / Kekuatan",
      "route": "Laluan Pemberian",
      "formularyStatus": "Status Formulari",
      "deaSchedule": "Kategori Kawalan DEA",
      "indications": "Indikasi",
      "contraindications": "Kontraindikasi",
      "interactions": "Interaksi Ubat",
      "sideEffects": "Kesan Sampingan",
      "dosageGuidelines": "Garis Panduan Dos",
      "specialPopulations": "Populasi Khas",
      "storage": "Penyimpanan"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "Baris Pengesahan Ahli Farmasi",
    "subtitle": "Semak dan sahkan arahan ubat yang menunggu",
    "pendingCount": "{{count}} menunggu",
    "refresh": "Muat Semula",
    "searchPlaceholder": "Cari mengikut ubat, nama pesakit atau MRN...",
    "priority": {
      "all": "Semua Keutamaan",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Rutin",
      "scheduled": "Dijadualkan"
    },
    "loadError": "Gagal memuatkan baris arahan ubat",
    "retry": "Cuba Semula",
    "empty": {
      "title": "Semua selesai",
      "description": "Tiada arahan ubat menunggu pengesahan."
    },
    "columns": {
      "patient": "Pesakit",
      "medication": "Ubat",
      "doseRouteFreq": "Dos / Laluan / Kekerapan",
      "priority": "Keutamaan",
      "orderingProvider": "Doktor Pemberi Arahan",
      "ordered": "Masa Arahan",
      "actions": "Tindakan"
    },
    "row": {
      "unknown": "Tidak diketahui",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "Terkawal {{schedule}}",
      "providerFallback": "Doktor #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "Sahkan",
      "verifyTooltip": "Sahkan arahan ubat ini",
      "reject": "Tolak",
      "rejectTooltip": "Tolak dan hentikan",
      "confirmReject": "Sahkan",
      "cancelReject": "Batal",
      "rejectReasonPlaceholder": "Sebab penolakan..."
    },
    "toast": {
      "verifySuccess": "Ubat #{{id}} disahkan",
      "verifyError": "Gagal mengesahkan ubat",
      "rejectSuccess": "Ubat #{{id}} ditolak dan dihentikan",
      "rejectError": "Gagal menolak ubat",
      "rejectReasonRequired": "Sila berikan sebab penolakan",
      "notIndependent": "Pemberi preskripsi tidak boleh mengesahkan pesanannya sendiri.",
      "overrideSuccess": "Pesanan {{id}} diaktifkan tanpa pengesahan ahli farmasi",
      "overrideError": "Gantian tidak dapat direkodkan",
      "overrideReasonRequired": "Gantian memerlukan kod sebab dan justifikasi"
    },
    "verifyDialog": {
      "title": "Sahkan pesanan ubat",
      "instruction": "Sahkan setiap pemeriksaan yang anda lakukan. Keempat-empatnya wajib — semakan separa bukan pengesahan.",
      "checks": {
        "allergy": "Saya menyemak pesanan ini terhadap alahan pesakit",
        "interaction": "Saya menyemak interaksi ubat",
        "duplicateTherapy": "Saya menyemak terapi berulang",
        "doseRange": "Saya menyemak dos untuk pesakit ini"
      },
      "cancel": "Batal",
      "confirm": "Sahkan pesanan"
    },
    "override": {
      "action": "Ganti",
      "confirm": "Rekod gantian",
      "cancel": "Batal",
      "tooltip": "Teruskan tanpa pengesahan ahli farmasi. Sebab direkodkan; tidak memenuhi semakan farmasi ubat amaran tinggi.",
      "codeLabel": "Kod sebab gantian",
      "codePlaceholder": "Pilih sebab…",
      "justificationLabel": "Justifikasi gantian",
      "justificationPlaceholder": "Mengapa diteruskan tanpa semakan farmasi?",
      "code": {
        "pharmacyClosed": "Farmasi ditutup",
        "urgentClinicalNeed": "Keperluan klinikal mendesak",
        "pharmacyUnreachable": "Farmasi tidak dapat dihubungi"
      }
    },
    "clarify": {
      "action": "Penjelasan",
      "tooltip": "Farmasi mengekod pesanan ini secara berbeza. Selesaikan sebelum ubat boleh diberi.",
      "heading": "Farmasi mengekodnya berbeza",
      "holding": "(menahan pesanan)",
      "upheld": "Pesanan kekal",
      "upheldTooltip": "Pesanan asal betul; sediakan seperti tertulis.",
      "amended": "Saya telah pindanya",
      "amendedTooltip": "Rekod bahawa pesanan telah diubah.",
      "adopt": "Terima versi farmasi",
      "adoptTooltip": "Terima versi terkod di bawah perjanjian amalan kolaboratif atau protokol P&T.",
      "close": "Tutup",
      "toast": {
        "resolved": "Penjelasan selesai; pesanan kembali untuk pengesahan",
        "error": "Penjelasan tidak dapat diselesaikan"
      }
    }
  },
  "reconciliation": {
    "title": "Penyelarasan Ubat",
    "subtitle": "{{patient}} | {{mrn}} | Lawatan #{{encounter}}",
    "complete": "Selesaikan Penyelarasan",
    "loading": "Memuatkan ubat...",
    "column": {
      "home": "Ubat di Rumah",
      "inpatient": "Ubat Pesakit Dalam",
      "discharge": "Ubat Pulang"
    },
    "emptyHome": "Tiada ubat di rumah ditemui.",
    "emptyInpatient": "Tiada ubat pesakit dalam ditemui.",
    "emptyDischarge": "Belum ada ubat pulang. Pilih sambung atau ubah ubat dari lajur lain.",
    "changedFromHome": "Berbeza daripada ubat di rumah",
    "action": {
      "continue": "Sambung",
      "modify": "Ubah",
      "discontinue": "Hentikan",
      "discontinueShort": "D/C",
      "newOrder": "Baharu"
    },
    "addToDischarge": "Tambah ke ubat pulang",
    "remove": "Buang",
    "modifyForm": {
      "title": "Ubah Ubat",
      "dose": "Dos",
      "route": "Laluan Pemberian",
      "frequency": "Kekerapan",
      "dosePlaceholder": "cth. 500mg",
      "routePlaceholder": "cth. PO",
      "frequencyPlaceholder": "cth. BID",
      "cancel": "Batal",
      "save": "Simpan"
    },
    "back": "Kembali",
    "toast": {
      "completed": "Penyelarasan ubat selesai",
      "completeError": "Gagal menyelesaikan penyelarasan",
      "atLeastOne": "Sila selaraskan sekurang-kurangnya satu ubat sebelum menyelesaikan"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "Kalkulator Dos",
      "weightLabel": "Berat Pesakit (kg) *",
      "heightLabel": "Tinggi (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "cth. 70",
      "heightPlaceholder": "cth. 170",
      "gfrPlaceholder": "Pilihan",
      "bsaLabel": "BSA Dikira (Mosteller):",
      "calculate": "Kira Dos",
      "error": "Gagal mengira dos. Backend mungkin tidak mempunyai data dos untuk ubat ini.",
      "renalAdjustment": "Pelarasan Buah Pinggang:",
      "originalDose": "Dos asal:",
      "min": "Min:",
      "max": "Maks:",
      "recommended": "Disyorkan: {{dose}} {{unit}}",
      "apply": "Guna Dos",
      "method": {
        "weightBased": "Berasaskan Berat",
        "bsaBased": "Berasaskan BSA",
        "flat": "Dos Tetap",
        "renalAdjusted": "Dilaras Buah Pinggang"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "Preskripsi Ubat",
    "submit": "Preskripsi",
    "navButton": "Preskripsi",
    "noActiveEncounter": "Preskripsi mesti dilampirkan pada pertemuan aktif. Buka atau masukkan pesakit ini ke pertemuan sebelum membuat preskripsi.",
    "fields": {
      "medication": "Ubat",
      "dose": "Dos",
      "doseUnit": "Unit",
      "route": "Laluan",
      "frequency": "Kekerapan",
      "frequencyDescription": "Keterangan kekerapan",
      "duration": "Tempoh",
      "durationUnit": "Unit tempoh",
      "totalDoses": "Jumlah dos",
      "isPrn": "PRN (bila perlu)",
      "prnIndication": "Indikasi PRN",
      "administrationInstructions": "Arahan pemberian",
      "patientInstructions": "Arahan pesakit",
      "quantityDispensed": "Kuantiti diberi",
      "refillsAuthorized": "Isi semula dibenarkan",
      "allowSubstitution": "Benarkan gantian generik",
      "pharmacyNotes": "Nota farmasi",
      "indication": "Indikasi",
      "clinicalIndication": "Indikasi klinikal",
      "priority": "Keutamaan"
    },
    "sections": {
      "drug": "Ubat",
      "dosing": "Dos",
      "durationPrn": "Tempoh & PRN",
      "instructions": "Arahan",
      "dispensing": "Pemberian",
      "clinical": "Klinikal"
    },
    "doseUnitPlaceholder": "cth. mg",
    "drugSearch": {
      "placeholder": "Cari formulari…",
      "noResults": "Tiada ubat formulari yang sepadan",
      "clear": "Kosongkan pilihan",
      "catalogRequired": "Pilih ubat dari formulari untuk dipreskripsi",
      "catalogOnly": "Hanya ubat formulari boleh dipreskripsi, supaya setiap semakan keselamatan dapat dijalankan.",
      "controlledBadge": "Terkawal — Jadual {{schedule}}",
      "controlledTag": "Terkawal",
      "highAlertBadge": "Ubat Kewaspadaan Tinggi",
      "highAlertTag": "Kewaspadaan Tinggi",
      "contraindications": "Kontraindikasi: {{text}}"
    },
    "route": {
      "oral": "Oral (PO)",
      "iv": "Intravena (IV)",
      "subcutaneous": "Subkutan (SC)",
      "intramuscular": "Intramuskular (IM)",
      "topical": "Topikal",
      "inhalation": "Sedutan",
      "rectal": "Rektal (PR)",
      "ophthalmic": "Oftalmik",
      "transdermal": "Transdermal"
    },
    "frequency": {
      "QD": "Sekali sehari (QD)",
      "BID": "Dua kali sehari (BID)",
      "TID": "Tiga kali sehari (TID)",
      "QID": "Empat kali sehari (QID)",
      "Q4H": "Setiap 4 jam (Q4H)",
      "Q6H": "Setiap 6 jam (Q6H)",
      "Q8H": "Setiap 8 jam (Q8H)",
      "Q12H": "Setiap 12 jam (Q12H)",
      "QHS": "Sebelum tidur (QHS)",
      "PRN": "Bila perlu (PRN)",
      "STAT": "Segera (STAT)"
    },
    "durationUnit": {
      "days": "Hari",
      "weeks": "Minggu",
      "months": "Bulan",
      "doses": "Dos"
    },
    "priority": {
      "routine": "Rutin",
      "asap": "Secepat mungkin",
      "stat": "Segera"
    },
    "validation": {
      "prnIndicationRequired": "Indikasi PRN diperlukan untuk pesanan bila perlu"
    },
    "contextBar": {
      "ariaLabel": "Konteks preskripsi",
      "allergies": {
        "label": "Alahan",
        "none": "Tiada alahan diketahui",
        "severe": "Teruk"
      },
      "weight": {
        "label": "Berat",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "Tidak direkodkan"
      },
      "renal": {
        "label": "Fungsi buah pinggang",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "Fungsi buah pinggang tidak diketahui",
        "source": {
          "reported": "dilaporkan",
          "computed": "dikira",
          "unknown": "tidak diketahui"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "Ubat telah dipreskripsi",
      "error": "Tidak dapat membuat pesanan. Sila cuba lagi.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "Dipreskripsi dengan nasihat keselamatan",
      "continue": "Teruskan"
    },
    "safetyReview": {
      "title": "Semakan Keselamatan Diperlukan",
      "proceed": "Batal Ganti & Preskrip",
      "cancel": "Batal",
      "reasonPrompt": "Pilih sebab penggantian…",
      "freeTextLabel": "Butiran tambahan",
      "freeTextPlaceholder": "Tambah konteks klinikal (pilihan)",
      "hardBlockNote": "Blok ini tidak boleh diganti.",
      "cannotOverride": "Preskripsi ini tidak boleh diteruskan — satu atau lebih blok tidak boleh diganti.",
      "blockKind": {
        "cds_contraindication": "Kontraindikasi",
        "cds_unavailable": "Saringan keselamatan tidak tersedia",
        "renal_contraindication": "Kontraindikasi buah pinggang",
        "dose_range": "Dos di luar julat disyorkan",
        "pregnancy_contraindication": "Risiko kehamilan",
        "unknown": "Blok keselamatan tambahan"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "Sejarah disemak secara manual",
        "NO_KNOWN_RISK_THIS_PATIENT": "Tiada risiko diketahui untuk pesakit ini",
        "URGENT_CLINICAL_NEED": "Keperluan klinikal segera",
        "OTHER": "Lain-lain (nyatakan)",
        "BENEFIT_OUTWEIGHS_RISK": "Manfaat mengatasi risiko",
        "DOSE_REDUCED_PER_PROTOCOL": "Dos dikurangkan mengikut protokol",
        "EGFR_NOT_REPRESENTATIVE": "eGFR tidak mewakili",
        "SPECIALIST_ADVICE": "Nasihat pakar",
        "PATIENT_TOLERANT": "Pesakit bertoleransi dengan dos ini",
        "SPECIALIST_PROTOCOL": "Mengikut protokol pakar",
        "TITRATING_TO_EFFECT": "Titrasi mengikut kesan",
        "RANGE_NOT_APPLICABLE": "Julat tidak berkenaan",
        "STATUS_CONFIRMED_NEGATIVE": "Status kehamilan disahkan negatif",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "Manfaat melebihi risiko kepada janin",
        "CONTRACEPTION_CONFIRMED": "Kontraseptif berkesan disahkan",
        "PREGNANCY_BEING_TERMINATED": "Kehamilan sedang ditamatkan"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
